import { MoneyInput } from "@/components/common/MoneyInput";
import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const INVOICE_TYPES = ["Edu fee", "Tiket fee", "Kanri hi", "Lainnya"];
const empty = () => ({ type: "Edu fee", label: "", amount: "" });

export function InvoiceList({ value = [], onChange, testId = "invoice-list" }) {
  const rows = value.length ? value : [empty()];
  const set = (i, patch) => onChange(rows.map((r, j) => (j === i ? { ...r, ...patch } : r)));
  const total = rows.reduce((a, r) => a + (Number(r.amount) || 0), 0);
  return (
    <div className="space-y-1.5" data-testid={testId}>
      {rows.map((r, i) => (
        <div key={i} className="flex items-center gap-2">
          <span className="w-5 shrink-0 text-right font-mono text-xs text-muted-foreground">{i + 1}.</span>
          <select value={r.type} onChange={(e) => set(i, { type: e.target.value })} className="h-9 w-32 shrink-0 rounded-md border bg-background px-2 text-sm" data-testid={`${testId}-type-${i}`}>
            {INVOICE_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
          {r.type === "Lainnya" && <Input value={r.label || ""} onChange={(e) => set(i, { label: e.target.value })} placeholder="Jenis invoice (ketik manual)" data-testid={`${testId}-label-${i}`} />}
          <MoneyInput value={r.amount} onChange={(v) => set(i, { amount: v })} placeholder="Nominal" className="w-40 shrink-0" testId={`${testId}-amount-${i}`} />
          <Button type="button" size="icon" variant="ghost" className="h-8 w-8 shrink-0" onClick={() => onChange(rows.length > 1 ? rows.filter((_, j) => j !== i) : [empty()])} data-testid={`${testId}-remove-${i}`}><X className="h-4 w-4" /></Button>
        </div>
      ))}
      <div className="flex items-center justify-between">
        <Button type="button" size="sm" variant="outline" onClick={() => onChange([...rows, empty()])} data-testid={`${testId}-add-btn`}><Plus className="mr-1 h-4 w-4" />Tambah invoice</Button>
        <span className="font-mono text-xs text-muted-foreground">Total Rp {total.toLocaleString("id-ID")}</span>
      </div>
    </div>
  );
}
